// packages/gatsby-theme-faq/src/gatsby-theme-pagebuilder/components/blocks/faquestions/index.js
export default () => null;
